import { CreateAvatarStoreProvider } from '@/pages/avatar/common/context';
import { AvatarType } from '@/pages/avatar/common/types';
import { AvatarPage } from './AvatarPage';

export const AvatarCreateExpressPage = () => {
    return (
        <CreateAvatarStoreProvider type={AvatarType.Express}>
            <AvatarPage />
        </CreateAvatarStoreProvider>
    );
};
